

<div class="row">
  <div class="col-md-10"></div>
  <div class="col-md-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>

<mat-dialog-content>
  <div class="row ">
    <div class="col-md-12 text-center mb-4">
      <img class="img-fluid RentalVehicleNotAvailable" src='assets/img/RentalVehicleNotAvailable.svg' />
    </div>
  </div>
  <div class="row ">
    <div class="col-md-12">
      <h3 class="RentalVehicleTitle" mat-dialog-title >{{ 'Oops' | translate }} ...</h3>
    </div>
  </div>
  <div class="row ">
    <div class="col-md-12">
      <p>{{ msg | translate }}</p>
    </div>
  </div>
  <div class="row ">
    <div class="col-md-12">
      <button (click)="GoToSearchResults()" type="submit" class="btn default-btn mr-3" mat-button>{{ 'GoToSearchResults' | translate }}</button>
      <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
    </div>
  </div>
</mat-dialog-content>


